import React from 'react';
import { useCountDown } from 'ahooks';
import { defaultConfig, BANNER_STATUS } from '../config';
import { LangText } from '../textLang';
import styled from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

interface BannerCountDownProps {
    handleEnd: () => void;
    activityDateArr: [string, string];
    data: any;
    status: string;
}

const BannerCountDown: React.FC<BannerCountDownProps> = ({ handleEnd, activityDateArr = [], data, status }) => {
    const { useLang, useRouter, getSystemTime } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('appreciationday');
    const activityEndDate = status === BANNER_STATUS.activity ? activityDateArr[1] : activityDateArr[0];
    const timeLine = activityEndDate ? new Date(`${activityEndDate.replaceAll('-', '/')} GMT+8`).getTime() : getSystemTime();
    const langTxt = LangText[locale] || LangText['us'];

    const [, formattedRes] = useCountDown({
        // leftTime: now - Number(startTime),
        leftTime: timeLine - getSystemTime(),
        onEnd: () => handleEnd(),
    });
    const { days = 8, hours, minutes, seconds } = formattedRes;
    const { countdownBgColor, countdownNumColor, countdownTextColor, align = defaultConfig.align, activityType } = data;

    const styleComp: any = {
        '--member-banner-countdownBgColor': countdownBgColor || defaultConfig.countdownBgColor,
        '--member-banner-countdownNumColor': countdownNumColor || defaultConfig.countdownNumColor,
        '--member-banner-countdownTextColor': countdownTextColor || defaultConfig.countdownTextColor,
    };

    const handleCompletion = (val: number) => (val < 10 ? `0${val}` : val);

    return (
        <div className={`${styled.banner_countdown} ${styled[`banner_countdown_${align}`]}`} style={styleComp}>
            {days >= 1 && (
                <>
                    <div className={activityType}>
                        <span className="time">{handleCompletion(days)}</span>
                        <br />
                        <span>{langTxt.day}</span>
                    </div>
                    <span>:</span>
                </>
            )}
            <div className={activityType}>
                <span className="time">{handleCompletion(hours)}</span>
                <br />
                <span>{langTxt.hour}</span>
            </div>
            <span>:</span>
            <div className={activityType}>
                <span className="time">{handleCompletion(minutes)}</span>
                <br />
                <span>{langTxt.min}</span>
            </div>
            <span>:</span>
            <div className={activityType}>
                <span className="time">{handleCompletion(seconds)}</span>
                <br />
                <span>{langTxt.sec}</span>
            </div>
        </div>
    );
};

export default BannerCountDown;
